export default __webpack_public_path__ + "static/media/selenium.3c6d3cfa.svg";